import { z } from '@exodus/zod';
import KeyIdentifier from '@exodus/key-identifier';
const keyIdentifierLikeSchema = z
    .custom((value) => KeyIdentifier.validate(value))
    .transform((value) => new KeyIdentifier(value));
export const keySourceSchema = z.strictObject({
    keyId: keyIdentifierLikeSchema,
    seedId: z.string(),
});
export const encryptSecretBoxParamsSchema = keySourceSchema.extend({
    data: z.instanceof(Buffer),
    deriveSecret: z.boolean().optional(),
});
export const decryptSecretBoxParamsSchema = encryptSecretBoxParamsSchema;
export const encryptBoxParamsSchema = keySourceSchema.extend({
    data: z.instanceof(Buffer),
    toPublicKey: z.instanceof(Buffer),
});
export const decryptBoxParamsSchema = keySourceSchema.extend({
    data: z.instanceof(Buffer),
    fromPublicKey: z.instanceof(Buffer),
});
export const validated = (fn, schema) => (params) => {
    const parsed = schema.parse(params);
    return fn(parsed);
};
